import React from "react";

const PlayIcon = () => {
  return (
    <svg
      aria-hidden={true}
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.53548 0.151387C1.38284 0.0562293 1.20791 0.00404912 1.02874 0.000226294C0.849568 -0.00359654 0.67263 0.0410762 0.516174 0.129639C0.359717 0.218201 0.229404 0.347447 0.138671 0.504051C0.0479381 0.660655 6.89763e-05 0.838947 0 1.02055V10.9795C6.89763e-05 11.1611 0.0479381 11.3393 0.138671 11.4959C0.229404 11.6526 0.359717 11.7818 0.516174 11.8704C0.67263 11.9589 0.849568 12.0036 1.02874 11.9998C1.20791 11.9959 1.38284 11.9438 1.53548 11.8486L9.5205 6.86916C9.66705 6.77778 9.78806 6.64989 9.87199 6.49768C9.95593 6.34548 10 6.17402 10 5.99966C10 5.8253 9.95593 5.65384 9.87199 5.50164C9.78806 5.34943 9.66705 5.22154 9.5205 5.13016L1.53548 0.151387Z"
        fill="#666666"
      />
    </svg>
  );
};

export default PlayIcon;
